export const fabricator_quote_url: string = "fabricator_quote";